import React from 'react';
import { compose, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import LowPriority from '@material-ui/icons/LowPriority';
import AddMenuEventDialog from '../molecules/AddMenuEventDialog';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(
  withState('openChange', 'updateOpenChange', false),
  withState('openChangeConfirm', 'updateOpenChangeConfirm', false),
  withState('menuEventId', 'setMenuEventId', null)
);

const button = enhance(
  ({
    classes,
    openChange,
    updateOpenChange,
    params,
    onClickAction,
    message,
    setMessage,
    openChangeConfirm,
    updateOpenChangeConfirm,
    titleStatus,
    menuEventId,
    setMenuEventId
  }) => {
    const cancelAction = () => updateOpenChange(false);
    const changeAction = paramChange => {
      const paramSubmit = {
        menuId: paramChange.id,
        menuEventId: parseInt(menuEventId, 10)
      };
      updateOpenChange(false);
      updateOpenChangeConfirm(false);
      onClickAction(paramSubmit);
    };
    const updateChange = () => {
      updateOpenChange(true);
      setMenuEventId(params.menuEventId);
    };

    return (
      <div>
        <Button
          color="primary"
          onClick={() => updateChange(true)}
          disabled={
            !(
              params.menuEvents &&
              params.menuEvents.length > 0 &&
              params.subscriptionCheck === false
            ) || params.menuChildType === 5
          }
        >
          <LowPriority className={classes.leftIcon} />
          {titleStatus}
        </Button>
        <AddMenuEventDialog
          openChange={openChange}
          updateOpenChange={updateOpenChange}
          cancelAction={cancelAction}
          changeAction={() => changeAction(params)}
          target="Change"
          menuEventId={menuEventId}
          setMenuEventId={setMenuEventId}
          params={params}
          message={message}
          setMessage={setMessage}
          openChangeConfirm={openChangeConfirm}
          updateOpenChangeConfirm={updateOpenChangeConfirm}
        />
      </div>
    );
  }
);

export default withStyles(styles)(button);
